import React from 'react'
import AvatareModelTraining from "../../Administration/AvatareModelTraining/AvatareModelTraining";
import { useNavigate } from 'react-router-dom';
;

const AvataresContainer = ({ avatares,getData, SetRerender, trainmymodel,totalCredits,setChangeCredits,filterItems }) => {
  const navigate= useNavigate();
    const SelectModel = (botId) => {
        if (window.location.href.split("/")[4] == "trainBySubject") {
            navigate("/classroom/selectSubjectsToTrain/" + botId)
        }
        else {
            navigate("/classroom/selectModel/" + botId)
        }
    }
    React.useEffect(() => {
    }, [])
    return (
        <div className='flex gap-3 flex-wrap'>
          
          {avatares?.map((avatare) => (
            <div >
              <AvatareModelTraining
                AllCredits={totalCredits}
                trainmymodel={trainmymodel}
                BotId={avatare.BotId}
                name={avatare.BotName}
                description={avatare.BotDescription}
                button_message={avatare.buttonMess}
                emoji={avatare?.emojiS3Link}
                SetRerender={SetRerender}
                SelectModel={SelectModel}
                setChangeCredits={setChangeCredits}
                getData={getData}
              />
            </div>
          )
        )}
      </div>
    )
}

export default AvataresContainer